module.exports = __webpack_public_path__ + "static/chemical-synthesis-walkthrough-c3022a7e32a8678559c70e035887f562.pdf";